// extracted by mini-css-extract-plugin
export default {"wrapper":"PayPal_wrapper__XAWfJ","spinner":"PayPal_spinner__VDm+H"};